import request from '@/common/request'
import { AxiosRequestConfig } from 'axios'
import { Page } from '@/models/Page'
import {
	DadosDaIntegracaoDeEmail,
	EnvioDeEmail,
	IntegracaoDeEmailDaLoja,
	StatusDeEnvioDeEmail,
	TipoDeEnvioDeEmail,
} from '@/models/email/EnvioDeEmail'

const basePathDaLoja = (lojaId: string) => `/lojas/${lojaId}/integracao-de-email`

export const buscarIntegracaoDeEmail = (lojaId: string): Promise<IntegracaoDeEmailDaLoja> =>
	request.get(basePathDaLoja(lojaId))

export const salvarIntegracaoDeEmail = (
	lojaId: string,
	dados: DadosDaIntegracaoDeEmail,
): Promise<IntegracaoDeEmailDaLoja> =>
	request.put(basePathDaLoja(lojaId), dados)

export const enviarEmailDeTeste = (
	lojaId: string,
	dados: DadosDaIntegracaoDeEmail & { destinatario: string },
): Promise<IntegracaoDeEmailDaLoja> =>
	request.post(`${basePathDaLoja(lojaId)}/teste`, dados)

export interface FiltroDeEnviosDeEmail {
	lojasIds?: string[]
	status?: StatusDeEnvioDeEmail | null
	tipo?: TipoDeEnvioDeEmail | null
	dataInicial?: string
	dataFinal?: string
	busca?: string
	page: number
	size: number
	sort: string[]
}

export const listarEnviosDeEmail = (
	filtro: FiltroDeEnviosDeEmail,
	config?: AxiosRequestConfig,
): Promise<Page<EnvioDeEmail>> =>
	request.get('/envios-de-email', { params: filtro, ...config })
